import { useEffect,useState } from 'react';
import _ from 'underscore';

interface WindowSize {
  width: number;
  height: number;
}

const RESIZE_DEBOUNCE_MS = 300;

export function useWindowSize(): [WindowSize, React.Dispatch<React.SetStateAction<WindowSize>>] {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = _.debounce(() => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }, RESIZE_DEBOUNCE_MS);

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      handleResize.cancel?.();
      (handleResize as any).clear?.();
    };
  }, []);

  return [windowSize, setWindowSize];
}
